import axios from 'axios';

const get = (customPath, id) => axios.get(`${customPath}/${id}/responsaveis`);

export default {
  get,
};
